export const siteMeta = {
  name: "五一爆料",
  slogan: "揭开节日背后的真相",
  desc: "专注五一劳动节假期安排、调休争议、节日消费与出游避坑的独立观察平台。",
};

export const navLinks = [
  { id: "hot", label: "今日聚焦" },
  { id: "topic", label: "核心专题" },
  { id: "diaoxiu", label: "调休争议" },
  { id: "jiqi", label: "假期黑幕" },
  { id: "jingqu", label: "景区套路" },
  { id: "xiaofei", label: "消费陷阱" },
  { id: "shengming", label: "用户之声" },
  { id: "wenda", label: "热点问答" },
  { id: "guanyu", label: "关于我们" },
];

export const tickerNews = [
  "国务院办公厅发布最新通知：2026年劳动节放假安排正式出炉",
  "多地景区被曝五一期间暗藏'隐形消费'，官方表态将专项排查",
  "调休争议再起：'拼出五天假、拆散两个周末'引热议",
  "五一出行高峰预警：多个热门景区发布限流公告",
  "文旅部提示：警惕'低价一日游'背后捆绑购物陷阱",
  "消费券发放后商家悄悄涨价？多地市场监管介入调查",
  "专家解读：今年调休为何仍争议不断？",
  "五一酒店预订量同比增长，热门城市一房难求",
];

export const heroReports = [
  {
    tag: "头条",
    title: "2026劳动节放假安排公布：调休再成焦点，'拼假'逻辑还能说服谁？",
    lead: "当'五天小长假'背后藏着两个被打散的周末，调休是否真的划算？我们拆解每一次调休背后的行政逻辑与民意落差。",
    date: "2026-04-12",
    reads: "12.6w",
    image: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%20of%20a%20wall%20calendar%20with%20red%20crossed%20dates%20and%20warm%20paper%20texture%2C%20vermilion%20and%20cream%20palette%2C%20bold%20serif%20typography%20overlay%2C%20documentary%20mood%2C%20high%20detail%20editorial%20photography&width=1200&height=800&seq=mayday-hero-01&orientation=landscape",
  },
  {
    tag: "深读",
    title: "谁在制造'人从众'？五一景区限流与接待上限背后的生意经",
    lead: "看似贴心的限流公告，为何门票反而卖得更好？景区承载量数字由谁说了算？一线从业者揭开客流控制的真相。",
    date: "2026-04-08",
    reads: "9.1w",
    image: "https://readdy.ai/api/search-image?query=crowded%20mountain%20scenic%20spot%20with%20long%20queues%20of%20tourists%20in%20spring%2C%20warm%20sunset%20light%2C%20cinematic%20documentary%20photo%2C%20cream%20and%20vermilion%20tones%2C%20realistic%20editorial%20photography&width=1200&height=800&seq=mayday-hero-02&orientation=landscape",
  },
];

export const topicNav = [
  { id: "diaoxiu", title: "调休争议", en: "SHIFTS", icon: "ri-calendar-2-line", color: "primary", desc: "拆解每一次拼假逻辑" },
  { id: "jiqi", title: "假期黑幕", en: "HOLIDAY", icon: "ri-scales-3-line", color: "accent", desc: "放假安排背后真相" },
  { id: "jingqu", title: "景区套路", en: "SCENERY", icon: "ri-landscape-line", color: "secondary", desc: "出游避坑实用指南" },
  { id: "xiaofei", title: "消费陷阱", en: "SPENDING", icon: "ri-shopping-bag-3-line", color: "primary", desc: "节日花钱防骗手册" },
];

export const diaoxiuArticles = [
  {
    tag: "深度解读",
    title: "调休三十年：从'挪假'到'拼假'，一次长假的经济账",
    excerpt: "调休制度从何而来？为何越是希望连休，民众抵触越大？我们从政策演变与经济学角度还原调休的来龙去脉。",
    date: "2026-04-15", reads: "8.4w",
  },
  {
    tag: "数据",
    title: "调研：超六成受访者认为'调休换长假'得不偿失",
    excerpt: "一份覆盖上万名网民的问卷显示，休息质量与工作节奏成为争议核心，'被调休'感受远高于'享长假'。",
    date: "2026-04-13", reads: "6.2w",
  },
  {
    tag: "视角",
    title: "从春节到五一，为什么我们总在讨论'该不该调休'",
    excerpt: "当放假安排成为每年固定热搜，我们真正在意的或许是工作与生活边界的重新划定。",
    date: "2026-04-10", reads: "5.1w",
  },
];

export const jiqiArticles = [
  {
    tag: "揭秘",
    title: "五一放假通知为何总在'最后时刻'才发布？",
    excerpt: "从审批流程到跨部门协调，一张小小的放假安排表背后，藏着怎样的行政链条与谨慎？",
    date: "2026-04-11", reads: "7.3w",
  },
  {
    tag: "盘点",
    title: "近十年五一假期安排全梳理：哪次调休最'受伤'",
    excerpt: "我们用一张时间轴，回顾历年五一的放假天数、调休安排与网友真实反应，找出规律。",
    date: "2026-04-07", reads: "4.8w",
  },
  {
    tag: "常识",
    title: "法定节假日、公休日与调休，到底有什么区别？",
    excerpt: "别再把'连休五天'误当法定假日。一文看懂假期构成，保护自己的休息权益。",
    date: "2026-04-04", reads: "3.9w",
  },
];

export const jingquArticles = [
  {
    tag: "避坑",
    title: "盘点景区三大隐性收费：摆渡车、联票与'园区外'项目",
    excerpt: "门票看似便宜，进园却处处要加钱。我们走访多个景区，整理出一份隐性收费避坑清单。",
    date: "2026-04-14", reads: "9.7w",
  },
  {
    tag: "实探",
    title: "实探热门山岳景区：'限流'公告下的黄牛与黑导游",
    excerpt: "一票难求的背面是另一条灰色产业链，游客又该如何辨别正规渠道与高价陷阱？",
    date: "2026-04-09", reads: "6.8w",
  },
  {
    tag: "攻略",
    title: "五一错峰出行指南：避开人潮的五个小众思路",
    excerpt: "反向旅行、错峰时段与冷门选择，教你用更聪明的方式享受假期，不被套路支配。",
    date: "2026-04-05", reads: "5.5w",
  },
];

export const xiaofeiArticles = [
  {
    tag: "预警",
    title: "'低价一日游'的购物团，钱到底花在了哪里？",
    excerpt: "看似划算的价格背后，是强制购物与回扣分成。拆解低价团的资金流向与维权路径。",
    date: "2026-04-16", reads: "10.2w",
  },
  {
    tag: "维权",
    title: "遇到节假日涨价、捆绑销售，教你三步有效投诉",
    excerpt: "保留凭证、找准部门、说清诉求——掌握这三个要点，消费维权不再是无头苍蝇。",
    date: "2026-04-12", reads: "7.9w",
  },
  {
    tag: "提醒",
    title: "五一出游注意：这些'舌尖上的优惠'可能是新的坑",
    excerpt: "景区餐饮、民宿套餐、美食代金券……我们从细节教你识别隐藏消费与过期承诺。",
    date: "2026-04-06", reads: "4.6w",
  },
];

export const stats = [
  { value: "12.6w+", label: "全网热议", icon: "ri-fire-line" },
  { value: "4大", label: "追踪专题", icon: "ri-file-list-3-line" },
  { value: "120+", label: "调查文章", icon: "ri-edit-line" },
  { value: "98%", label: "读者好评", icon: "ri-thumb-up-line" },
];

export const readers = [
  {
    name: "阿K", city: "杭州", role: "互联网从业者",
    text: "调休那段分析很中立，终于有人把'为什么越调越累'讲清楚了，已推荐给同事。",
    tag: "调休争议",
  },
  {
    name: "林女士", city: "成都", role: "自由职业",
    text: "景区隐性收费清单太实用了，上次去古镇差点被联票套路，还好提前做了功课。",
    tag: "景区套路",
  },
  {
    name: "大鹏", city: "广州", role: "家庭出游者",
    text: "低价团的资金拆解让我学到很多，五一前果断取消了不靠谱的'超值'行程。",
    tag: "消费陷阱",
  },
  {
    name: "小满", city: "长沙", role: "学生",
    text: "假期安排的常识科普写得浅显，看完终于分清法定假和调休的区别，收藏了。",
    tag: "假期黑幕",
  },
];

export const faqs = [
  {
    q: "五一是法定节假日吗？调休又是怎么回事？",
    a: "劳动节(5月1日)是法定节假日，法律规定放假一天。而所谓'五一假期'往往是把法定假日与周末、以及通过调休(前后周末补班)拼凑出来的连休。简单说，你看到的'五天假'里，真正新增的带薪休息并不多，这也是很多人对调休感到'不划算'的原因。",
  },
  {
    q: "为什么景区一到五一就'限流'，门票反而更难买？",
    a: "限流本质是保障安全与游览体验的管理措施，但热门景区承载量有限，叠加节假日集中出行，供需失衡自然推高抢票难度。一些不规范渠道的黄牛、加价票也会加剧'一票难求'。建议通过景区官方小程序或授权平台预约，警惕来路不明的代订。",
  },
  {
    q: "遇到景区或商家节假日涨价、捆绑销售，怎么维权？",
    a: "先保留付款凭证、订单截图与沟通记录；随后可拨打12345或12315热线，向市场监管部门反映。若涉及价格明显高于标价、虚假宣传或强制交易，投诉时说明时间、地点与诉求，通常可得到有效受理与处理。",
  },
  {
    q: "'低价一日游'为什么便宜得离谱？能信吗？",
    a: "极低价往往通过引导购物、返点抽成来弥补成本，本质是'购物团'。此类行程容易压缩游览时间、诱导高价消费。出行前建议核实旅行社资质与合同条款，明确有无购物安排，切勿只图低价。",
  },
  {
    q: "五一出行人太多，有没有更舒服的选择？",
    a: "可以尝试反向旅行(去小众城市)、选择非高峰时段(如假期首日上午或最后一天)、错开最热门景区。提前规划、灵活调整目的地，往往能兼顾体验与预算，玩得更从容。",
  },
];

export const aboutPoints = [
  { title: "独立观察", icon: "ri-eye-line", desc: "不站队、不带货，用数据和事实还原节假日背后被忽略的细节。" },
  { title: "用户为先", icon: "ri-user-heart-line", desc: "每篇文章都从普通人的休息、出行与花钱体验出发，讲人话、给方法。" },
  { title: "拒绝标题党", icon: "ri-focus-3-line", desc: "爆点之外我们更在意准确，所有避坑与维权建议均有依据与出处意识。" },
  { title: "长期更新", icon: "ri-refresh-line", desc: "围绕假期与出行主题持续追踪，让每一次长假都过得明明白白。" },
];